module.exports = __webpack_public_path__ + "fonts/dxicons.e7b052cb.ttf";